import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "nav"]

  connect() {
    this.observer = new IntersectionObserver(this.#intersection, {
      threshold: 0,
    })
    this.observer.observe(this.headerTarget)
  }

  disconnect() {
    this.observer.disconnect()
  }

  #intersection = (entries) => {
    entries.forEach(entry => {
      const height = entry.isIntersecting ? 0 : this.navTarget.offsetHeight
      this.headerTarget.style.marginBottom = `${height}px`
      this.navTarget.classList.toggle("nav--sticky", !entry.isIntersecting)
      document
        .documentElement
        .classList
        .toggle("has-sticky-nav", !entry.isIntersecting)
    })
  }
}
